import React from "react";
import { Policy } from "../container";

const PolicyPage = () => (
  <div>
    <Policy />
  </div>
);

export default PolicyPage;
